<template>
  <div :class="sectionOnTop ? 'on-top' : 'column'">
    <spinner :visible="loadingSections"></spinner>
    <!-- Crea le selezioni stampabili, da mettere in un componente a parte -->
    <div class="report-sections" v-if="!loadingSections" :style="openedHeight" :class="activeToggle && showSection ? 'showSection' : ''">
      <div class="row-fluid sections-head" :class="activeToggle ? 'sections-head--clickable' : ''">
        <div class="btn btn-success sections-head__button" @click="toggleSection">{{ i18nJS.sezioni }}</div>
        <div v-if="showSection || !activeToggle" class="btn btn-success sections-head__button" @click="toggleAll">
          <span v-if="allSelected"> {{ i18nJS.deseleziona_tutto }} </span>
          <span v-if="!allSelected"> {{ i18nJS.select_all }} </span>
        </div>
      </div>
      <hr />
      <div class="sections-cont" v-if="newElement.sections" :style="height ? `height: ${height}px` : ''">
        <input type="hidden" :name="`${attrName}[sections]`" value="{}" :disabled="allSelected" />
        <div class="report-section" :key="reportSection.id" v-for="reportSection in sections">
          <input
            type="checkbox"
            :id="reportSection.id"
            :checked="newElement.sections[reportSection.id]"
            @change="checkboxChange(reportSection.id)"
            :value="reportSection.value"
            :name="`${attrName}[sections][${reportSection.id}]`"
          />
          <label :for="reportSection.id">{{ reportSection.t }}</label>
          <select
            v-if="reportSection.options && !reportSection.multiple"
            v-model="newElement.sections[reportSection.id]"
            :name="`${attrName}[sections][${reportSection.id}]`"
          >
            <option :value="option[0]" v-for="(option, index) in reportSection.options" :key="index">
              {{ option[1] }}
            </option>
          </select>
          <div v-if="reportSection.multiple" class="mychzn">
            <v-select2
              v-model="newElement.sections[reportSection.id]"
              :name="`${attrName}[sections][${reportSection.id}]`"
              :multiple="reportSection.multiple"
              :options-list="reportSection.options"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import spinner from '../../spinner';
import VSelect2 from '../../vSelect2';

export default {
  name: 'optionsSection',
  props: ['loadingSections', 'sections', 'element', 'attrName', 'sectionOnTop', 'activeToggle', 'height'],
  components: {
    VSelect2,
    spinner,
  },
  data() {
    return {
      newElement: {},
      showSection: false,
    };
  },
  mounted() {
    this.newElement = Object.assign({}, this.element);
  },
  watch: {
    sections: {
      immediate: true,
      handler() {
        this.populateElement();
      },
    },
    newElement: {
      immediate: true,
      handler(val) {
        this.$emit('update:element', val);
      },
    },
  },
  computed: {
    openedHeight() {
      if (this.height) {
        let openedHeight = 50 + parseInt(this.height);
        return `height: ${openedHeight}px;`;
      } else {
        return '';
      }
    },
    elementVoid() {
      return Object.keys(this.element).length === 0 || !this.element.sections;
    },
    i18nJS() {
      return window.i18nJS;
    },
    allSelected() {
      return (
        this.newElement &&
        this.newElement.sections &&
        !Object.values(this.newElement.sections).reduce((allSel, value) => allSel && !value, true)
      );
    },
  },
  methods: {
    populateElement() {
      if (!this.elementVoid) return;

      this.newElement['sections'] = {};
      this.sections.forEach((section) => {
        if (section.value) {
          this.newElement['sections'][section.id] = section.value;
        } else {
          this.newElement['sections'][section.id] = section.multiple ? [] : section.options[0][0];
        }
      });

      this.$emit('update:element', this.newElement);
    },
    toggleSection() {
      if (!this.activeToggle) return null;

      this.showSection = !this.showSection;
    },
    resetSection() {
      this.newElement.sections = this.newElement.discharge_against_staff_opinion
        ? this.defaultOptionsAgainstStaffOpinion
        : this.defaultOptions;
      this.newElement.setSections(this.sections);
    },
    toggleAll() {
      this.sections.forEach((section) => {
        let defaultValue = section.value;
        if (!defaultValue) {
          defaultValue = !section.multiple ? section.options[0][0] : [];
        }
        const newVal = this.allSelected ? null : defaultValue;
        setTimeout(() => {
          this.$set(this.newElement.sections, section.id, newVal);
        }, 10);
      });
    },
    dischargeAgainstStaffOpinionClicked() {
      this.newElement.discharge_against_staff_opinion = !this.newElement.discharge_against_staff_opinion;
      this.resetHeader();
      this.resetFooter();
      this.resetSection();
    },
    checkboxChange(reportSectionId) {
      const sectionValue = this.newElement.sections[reportSectionId];
      const section = this.sections.find((s) => s.id == reportSectionId);
      const defaultValue = section.options ? section.options[0][0] : section.value;
      let newVal = sectionValue == defaultValue ? null : defaultValue;
      this.$set(this.newElement.sections, reportSectionId, newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .report-sections {
    height: 800px;

    .sections-cont {
      height: 770px;
      margin-right: 10px;
    }
  }

  .report-section {
    margin-right: 10px;
  }

  .report-section {
    height: 35px;
  }

  label {
    display: inline;
  }
  select {
    width: 120px;
    margin-left: auto;
    padding: 0;
  }
}

.on-top {
  height: auto;

  .sections-head {
    border-bottom: 1px solid #ccc;
    justify-content: space-between;
    align-items: center;

    &--clickable {
      cursor: pointer;
    }

    &__title {
      font-weight: bold;
      transition: all 0.5s;
      width: 70%;
    }

    &__button {
      border-radius: 5px;
      background-color: var(--adv-secondary-color);
      padding: 7px 15px;
      font-size: 14px;
      cursor: pointer;
      color: #fff;
      margin-bottom: 4px;
    }

    &::before,
    &::after {
      display: none;
    }
  }

  .report-sections {
    width: 100%;
    height: 40px;
    overflow: hidden;
    transition: all 0.5s;

    &.showSection {
      height: 380px;
      overflow: auto;
      margin-bottom: 60px;
    }

    .report-section {
      height: 35px;

      input[type='checkbox'] {
        position: relative;
        top: 1px;
      }
    }

    .sections-cont {
      width: 100%;
      overflow: hidden;
      height: 320px;
    }

    label {
      display: inline;
      min-width: 180px;
    }

    select {
      width: 120px;
      margin: 0;
      padding: 0;
    }

    .mychzn {
      position: absolute;
      right: 0;
      top: -10px;
    }
  }
}

.report-sections {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;

  .sections-head {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .sections-cont {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .report-section {
    display: flex;
    align-items: baseline;
    position: relative;
  }

  input[type='checkbox'] {
    margin-right: 5px;
  }
}

.active-area {
  cursor: pointer;
}
</style>
